import React, { useEffect, useState } from 'react';
// import { PieCharts } from 'components/charts/PieCharts';
import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { AmDonutChart3D } from 'components/amcharts/donutChart';

import { getAllOrganizationEmployeeDetails } from 'service/UserService';
import { getOrgUserChart } from 'service/ChartService';
import { useSelector, useDispatch } from 'react-redux';
import { type RootState } from 'store';
import { strings } from 'i18n/Strings';
import { type OrganizationInfo } from 'types/pages';
import { setOnboardedEmail, setOrganizationInfo } from 'store/employeeDetails';

interface ChartType {
  category: string;
  value: number;
}

const Home = (): JSX.Element => {
  const dispatch = useDispatch();

  const { orgId } = useSelector((state: RootState) => state.onboarding);
  const { organizationInfo } = useSelector(
    (state: RootState) => state.employeeDetails,
  );
  const [userChart, setUserChart] = useState<ChartType[]>([]);
  const [loading, setLoading] = useState(false);
  const [employeeLoading, setEmployeeLoading] = useState(false);

  const getEmployeeData = async (): void => {
    if (orgId) {
      setLoading(true);
      setEmployeeLoading(true);
      getAllOrganizationEmployeeDetails(orgId.toString())
        .then((res) => {
          if (typeof res !== 'undefined' && 'orgInfo' in res) {
            const { orgInfo } = res as { orgInfo: OrganizationInfo };

            if (orgInfo) {
              const emails = orgInfo?.user
                ? orgInfo?.user?.map((e) => e.email)
                : [];
              dispatch(setOnboardedEmail(emails));
              dispatch(setOrganizationInfo(orgInfo));
            }
          }
        })
        .catch((err: Error) => {
          throw err;
        })
        .finally(() => {
          setEmployeeLoading(false);
        });
      getOrgUserChart(orgId)
        .then((result) => {
          const { data } = result;
          if (data) {
            setUserChart([
              {
                category: strings.displayText.noOfRegisteredUser,
                value: data?.registeredUserCount || 0,
              },
              {
                category: strings.displayText.noOfUnRegisteredUser,
                value: data?.unRegisteredUserCount || 0,
              },
            ]);
          }
        })
        .catch((err: Error) => {
          throw err;
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    getEmployeeData();
  }, [orgId]);

  return (
    <>
      {loading || employeeLoading || userChart.length === 0 ? null : (
        <Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Typography
                sx={{
                  fontSize: '20px',
                  marginRight: 1,
                  color: 'black',
                  fontWeight: 'bold',
                }}
              >
                {organizationInfo?.companyName} :
              </Typography>
              <Typography
                sx={{
                  fontSize: '16px',
                  marginTop: 0.2,
                  color: 'black',
                }}
              >
                {organizationInfo?.uniqueId}
              </Typography>
            </Box>
          </Box>

          <Box>
            <Grid
              direction="row"
              justifyContent="space-between"
              container
              columns={12.2}
              sx={{ display: 'flex', padding: 1 }}
            >
              <AmDonutChart3D
                id="user_chart1"
                data={userChart}
                height="500px"
                colors={['#B5DFC8', '#EEC033']}
              />
            </Grid>
          </Box>
        </Box>
      )}
    </>
  );
};

export default Home;
